import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.scss';
import './i18n';
import Routing from './components/Routing';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
//create a root
const root = ReactDOM.createRoot(container);

//Initial render
root.render(
    <>
    <React.StrictMode>
        <Router>
            <Routes>
                <Route path="/health" element={<h3>The App is Healthy.</h3>} />
            </Routes>
            <Routing />
        </Router>
        <div className="position-fixed top-0 end-0 p-2 toast-end pointer-none" style={{'zIndex': '1111'}} id="toastContainer"></div>
    </React.StrictMode>
    </>
);
reportWebVitals();